/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import CustomButtom from '../../components/CustomButtons/ButtonExt';
import I18n from '../../components/Translate/I18n';

function CustomSmallTextButtom({ ...props }) {
    const { callback, label, disabled, callbackParam, color } = props;
    return (
        <CustomButtom color={color} size="sm" disabled={disabled} onClick={() => callback(callbackParam)}>
            <I18n trans={label} />
        </CustomButtom>
    );
}

CustomSmallTextButtom.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object,
    label: PropTypes.string.isRequired,
};

export default CustomSmallTextButtom;
